<template>
    <div class="container">
        <div class="bs-docs-grid">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="alert alert-danger">
                        <h1>You can't access this while offline.</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
